var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconUserIdentityAccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.25,22A12.75,12.75,0,1,0,40,9.25,12.76457,12.76457,0,0,0,27.25,22Zm24,0A11.25,11.25,0,1,1,40,10.75,11.26294,11.26294,0,0,1,51.25,22Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.75,72V52A12.76457,12.76457,0,0,0,52,39.25H28A12.76457,12.76457,0,0,0,15.25,52V72h1.5V52A11.26294,11.26294,0,0,1,28,40.75H52A11.26294,11.26294,0,0,1,63.25,52V72Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.46973,45.46973l-4.83789,4.838a8.82181,8.82181,0,1,0,.885,1.236l5.01342-5.01349ZM40,63.25a7.25,7.25,0,1,1,5.57153-11.88208L40,56.93945l-3.46973-3.46972-1.06054,1.06054,4,4a.74971.74971,0,0,0,1.06054,0l5.88892-5.889A7.241,7.241,0,0,1,40,63.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserIdentityAccess);
export default __webpack_public_path__ + "static/media/icon_user_identity_access.57705a556c91b88db637b224fd865942.svg";
export { ForwardRef as ReactComponent };